import { render, staticRenderFns } from "./DismissalTagCategoryManageDialog.vue?vue&type=template&id=2d1493f5&scoped=true"
import script from "./DismissalTagCategoryManageDialog.vue?vue&type=script&lang=js"
export * from "./DismissalTagCategoryManageDialog.vue?vue&type=script&lang=js"
import style0 from "./DismissalTagCategoryManageDialog.vue?vue&type=style&index=0&id=2d1493f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1493f5",
  null
  
)

export default component.exports